/** SI-prefixed engineering formatting. */
const PREFIXES: [number, string][] = [
  [1e12, "T"],
  [1e9, "G"],
  [1e6, "M"],
  [1e3, "k"],
  [1, ""],
  [1e-3, "m"],
  [1e-6, "µ"],
  [1e-9, "n"],
  [1e-12, "p"],
  [1e-15, "f"],
];

export function siFormat(val: number | null | undefined, unit: string, digits = 4): string {
  if (val === null || val === undefined || Number.isNaN(val)) return "—";
  if (val === 0) return `0 ${unit}`;
  const abs = Math.abs(val);
  if (abs >= 1e15 || abs < 1e-15) return val.toExponential(digits - 1) + " " + unit;
  // String(Number(...)) strips toPrecision's exponent form ("1.0e+2" -> "100").
  const mantissa = (m: number) => String(Number(m.toPrecision(digits)));
  for (const [scale, prefix] of PREFIXES) {
    if (abs >= scale) {
      // Rounding can push the mantissa to 1000 (999.8 @ 3 digits) — bump the prefix.
      if (Math.abs(Number((val / scale).toPrecision(digits))) >= 1000) {
        const i = PREFIXES.findIndex(([s]) => s === scale);
        if (i > 0) {
          const [s2, p2] = PREFIXES[i - 1]!;
          return mantissa(val / s2) + " " + p2 + unit;
        }
      }
      return mantissa(val / scale) + " " + prefix + unit;
    }
  }
  return val.toExponential(digits - 1) + " " + unit;
}
